import React from 'react';
import { Breadcrumbs, Link } from '@material-ui/core/index';
import './breadcrumb.scss';

export interface Crumb {
  label: string;
  url: string;
}

function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <div className="breadcrumbs">
      <div className="u--paddingTop u--paddingBottom normalcrumbs crumbs">
        <div id="breadcrumb" className="breadcrumb">
          <Breadcrumbs aria-label="breadcrumbs">
            {crumbs.map((crumb, crumbIndex) => {
              return crumbIndex === crumbs.length - 1 ? (
                <span className="breadcrumb title--selected" key={crumb.label}>
                  {crumb.label}
                </span>
              ) : (
                <Link
                  className="breadcrumb title"
                  href={crumb.url}
                  key={crumb.label}
                >
                  {crumb.label}
                </Link>
              );
            })}
          </Breadcrumbs>
        </div>
      </div>
    </div>
  );
}

Breadcrumb.displayName = 'Breadcrumb';

export default Breadcrumb;
